import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incidents-report-pdf';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentsReportPdfEffects {

    IncidentsReportPdf$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENTS_REPORT_PDF),
        mergeMap((x: ac.GetIncidentsReportPdfAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentsReportPdf(x.incidentsReportRequest).pipe(
                map((result: any) => {
                    return new ac.GetIncidentsReportPdfErfolgreichAction(result, x.incidentsReportRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentsReportPdfFehlerAction(error, x.incidentsReportRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsReportingService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsReportingService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsReportingService);
        }
        return this.service;
    }
}
